import { RegionModel } from 'app/core/models/region.model';
import { InvoiceModel } from './invoice.model';

export class EstimatedReconciliationModel {
    public id: string;
    public created_date: Date;
    public address1: string;
    public address2: string;
    public city: string;
    public region_id: string;
    public region: RegionModel;
    public zip5: string;

    // Alternate recipient fields
    public use_alternate_recipient = false;
    public first_name: string | null = null;
    public last_name: string | null = null;

    public invoices: Array<InvoiceModel>;
}
